"use client";

import { ClientEnvironmentContext } from "@/utils/globalConfig";
import { SearchPage, SearchQueryProps, SearchResults } from "./SearchPage";
import { useContext } from "react";
import { ContentBlocks } from "@/components/organisms/contentBlocks";
import { Cultures } from "@/types/enums";
import { searchWithAlgoliaAPI } from "@/utils/searchAPI";

function SearchPageFactory({
	data,
	homePageIdentifier,
}: {
	data: any;
	homePageIdentifier?: string;
}): JSX.Element {
	const isInvestorsPage = homePageIdentifier === "investors";
	const clientEnvironment = useContext(ClientEnvironmentContext);
	const pageTitle = data?.blocks?.[0]?.content?.pageTitle;
	const culture = isInvestorsPage ? Cultures["en-US"] : Cultures["nl-NL"];

	if (!data) {
		throw new Error("No content passed to SearchPageFactory");
	}

	async function searchQuery({
		searchQuery,
		setSearchResultsCallback,
		pageInfo,
	}: SearchQueryProps) {
		try {
			const algoliaResponse = await searchWithAlgoliaAPI({
				query: searchQuery ?? "",
				page: pageInfo?.page ?? 1,
				pageSize: pageInfo?.pageSize ?? 12,
			});

			// Transform Algolia response to match existing SearchResults interface
			const searchResult: SearchResults = {
				results: algoliaResponse.results,
				totalItems: algoliaResponse.totalItems,
				totalPages: algoliaResponse.totalPages,
				currentPage: algoliaResponse.currentPage,
			};

			setSearchResultsCallback(searchResult);
		} catch (error) {
			console.error("Search failed:", error);
			// Provide empty results on error
			setSearchResultsCallback({
				results: [],
				totalItems: 0,
				totalPages: 0,
				currentPage: 1,
			});
		}
	}
	const contentBlocks = (
		<ContentBlocks
			blocksData={data.blocks}
			pagePath={clientEnvironment!.cmsHomePageCulture}
			culture={culture}
		/>
	);

	return (
		<SearchPage
			title={pageTitle || "search"}
			pageSize={12}
			searchQueryProps={searchQuery}
			contentBlocks={contentBlocks}
			homePageIdentifier={homePageIdentifier}
		/>
	);
}

export default SearchPageFactory;
